import React from 'react';
import { Image } from 'react-bootstrap';
import logo from './logo.png';

const MainLogo = props => (
  <Image src={logo} alt="Logo" className="img-fluid" style={{ cursor: 'pointer' }} {...props} />
);

export default MainLogo;
